import { ErrorsCaptureWrapperApi } from './ErrorsCaptureWrapperApi';
// This is a class which starts trace axios errors and keeps showAlertReportBtn state
var $InitErrorHandler = /** @class */ (function () {
    function $InitErrorHandler() {
        var _this = this;
        this._showAlertReportBtn = false;
        /**
         * @description initErrorHandler catch errors from api requests
         * and keeps showAlertReportBtn (shows bug-report button on alerts if it's true)
         * and sets alert config if provided
         * @param {TInitProps} props
         *
         */
        this.initErrorHandler = function (props) {
            var instance = props.instance, CriticalApiList = props.CriticalApiList, _a = props.showAlertReportBtn, showAlertReportBtn = _a === void 0 ? false : _a, alertConfig = props.alertConfig;
            _this.showAlertReportBtn = showAlertReportBtn;
            instance.interceptors.response.use(function (response) { return response; }, function (error) {
                ErrorsCaptureWrapperApi({
                    error: error,
                    CriticalApiList: CriticalApiList,
                    alertConfig: alertConfig,
                    showAlertReportBtn: showAlertReportBtn
                });
            });
        };
    }
    Object.defineProperty($InitErrorHandler.prototype, "showAlertReportBtn", {
        get: function () {
            return this._showAlertReportBtn;
        },
        set: function (value) {
            this._showAlertReportBtn = value;
        },
        enumerable: false,
        configurable: true
    });
    return $InitErrorHandler;
}());
export default new $InitErrorHandler();
